import { ImportIcon } from "@solar-icons/react/outline/import";
import { InboxArchiveIcon } from "@solar-icons/react/outline/inbox-archive";
import { TagPriceIcon } from "@solar-icons/react/outline/tag-price";
import { SafeSquareIcon } from "@solar-icons/react/outline/safe-square";
import { VerifiedCheckIcon } from "@solar-icons/react/outline/verified-check";
import { Link } from "react-router-dom";

const SIZE = 20;

export default [
    {
        key: "/import",
        icon: <ImportIcon size={SIZE} />,
        level: 0x1fff,
        label: "Import",
        children: [
            {
                key: "/import/awb",
                icon: <InboxArchiveIcon size={SIZE} />,
                level: 0x1fff,
                label: <Link to={"/import/awb"}>AWB Import</Link>,
            },
            {
                key: "/import/import_in",
                icon: <SafeSquareIcon size={SIZE} />,
                level: 0x1fff,
                label: <Link to={"/import/import_in"}>Import Gate In</Link>,
            },
            {
                key: "/import/import_verify",
                icon: <VerifiedCheckIcon size={SIZE} />,
                level: 0x1fff,
                label: <Link to={"/import/import_verify"}>Import Verify</Link>,
            },
            {
                key: "/import/import_report",
                icon: <TagPriceIcon size={SIZE} />,
                level: 0x1ff2,
                label: <Link to={"/import/import_report"}>Import Report</Link>,
            }
        ],
    },
];
